import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const chartData = [
  { name: "Mon", value: 30 },
  { name: "Tue", value: 45 },
  { name: "Wed", value: 60 },
  { name: "Thu", value: 40 },
  { name: "Fri", value: 80 },
  { name: "Sat", value: 50 },
  { name: "Sun", value: 70 },
];

export default function Dashboard() {
  return (
    <div className="p-6 w-full">

      {/* ---------- PAGE TITLE ---------- */}
      <h1 className="text-2xl font-semibold mb-6">Dashboard</h1>

      {/* ---------- CARDS TOP ROW ---------- */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
        <div className="bg-white rounded-2xl p-5 shadow-sm border">
          <p className="text-sm text-gray-500">Total Candidates</p>
          <h2 className="text-2xl font-semibold mt-2">1,245</h2>
        </div>

        <div className="bg-white rounded-2xl p-5 shadow-sm border">
          <p className="text-sm text-gray-500">Interviews Scheduled</p>
          <h2 className="text-2xl font-semibold mt-2">82</h2>
        </div>

        <div className="bg-white rounded-2xl p-5 shadow-sm border">
          <p className="text-sm text-gray-500">Shortlisted</p>
          <h2 className="text-2xl font-semibold mt-2">307</h2>
        </div>

        <div className="bg-white rounded-2xl p-5 shadow-sm border">
          <p className="text-sm text-gray-500">Rejected</p>
          <h2 className="text-2xl font-semibold mt-2">114</h2>
        </div>
      </div>

      {/* ---------- CHART + RIGHT STATS ---------- */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

        {/* Chart */}
        <div className="bg-white rounded-2xl p-6 shadow-sm border col-span-2">
          <h2 className="text-lg font-semibold mb-4">Weekly Activity</h2>
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={chartData}>
                <XAxis dataKey="name" stroke="#888" />
                <YAxis stroke="#888" />
                <Tooltip />
                <Bar dataKey="value" fill="#6366f1" radius={[8, 8, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Right Stats */}
        <div className="bg-white rounded-2xl p-6 shadow-sm border">
          <h2 className="text-lg font-semibold mb-4">Today’s Overview</h2>

          <div className="space-y-4">
            <div className="p-4 border rounded-xl">
              <p className="text-sm text-gray-500">New Applications</p>
              <h3 className="text-xl font-bold mt-1">54</h3>
            </div>

            <div className="p-4 border rounded-xl">
              <p className="text-sm text-gray-500">Shortlisted</p>
              <h3 className="text-xl font-bold mt-1">16</h3>
            </div>

            <div className="p-4 border rounded-xl">
              <p className="text-sm text-gray-500">Interviews Today</p>
              <h3 className="text-xl font-bold mt-1">5</h3>
            </div>

            <div className="p-4 border rounded-xl">
              <p className="text-sm text-gray-500">Pending Reviews</p>
              <h3 className="text-xl font-bold mt-1">22</h3>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
